import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !email.trim()) {
      toast.error("Please fill in both name and email.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { name, email });
      toast.success("Thanks for subscribing!");
      setName("");
      setEmail("");
    } catch (err) {
      toast.error("Subscription failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="sd-newsletter" data-testid="newsletter-section">
      <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12">
        <div>
          <h2 data-testid="newsletter-heading">Get Connected</h2>
          <p className="text-center text-white/95 mt-4 max-w-md mx-auto">
            Join our mailing list and social networks for special offers,
            events, and a chance to win burgers for life!
          </p>

          <form onSubmit={submit} className="mt-8 max-w-md mx-auto" data-testid="newsletter-form">
            <div className="grid grid-cols-[100px,1fr] gap-4 items-center mb-4">
              <label htmlFor="nl-name">Name</label>
              <input
                id="nl-name"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your name"
                data-testid="newsletter-name-input"
              />
            </div>
            <div className="grid grid-cols-[100px,1fr] gap-4 items-center mb-6">
              <label htmlFor="nl-email">E-mail</label>
              <input
                id="nl-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                data-testid="newsletter-email-input"
              />
            </div>
            <div className="text-center">
              <button type="submit" disabled={loading} data-testid="newsletter-submit">
                {loading ? "Subscribing..." : "Subscribe"}
              </button>
            </div>
            <p className="text-white/80 text-xs mt-6 text-center">
              By joining our newsletter, you agree to accept the latest news and
              offers via email. We do not sell or distribute your email.
            </p>
          </form>
        </div>

        <div className="flex flex-col items-center justify-center gap-6" data-testid="social-app-block">
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href="https://play.google.com/store/apps/details?id=com.foodbooking.clientapp"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="app-google-play"
            >
              <img
                src="/images/google_play.png"
                alt="Get it on Google Play"
                className="h-14"
              />
            </a>
            <a
              href="https://apps.apple.com/us/app/foodbooking/id1039788926"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="app-apple-store"
            >
              <img
                src="/images/app-store.png"
                alt="Download on the App Store"
                className="h-14"
              />
            </a>
          </div>
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href="https://www.yelp.com/biz/sub-delicious-lockport"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="social-yelp"
            >
              <img
                src="/images/yelp.png"
                alt="Find us on Yelp"
                className="h-14"
              />
            </a>
            <a
              href="https://www.facebook.com/Subdeliciouslockport/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="social-facebook"
            >
              <img
                src="/images/facebook.png"
                alt="Find us on Facebook"
                className="h-14"
              />
            </a>
          </div>
          <div className="text-white/90 text-sm text-center mt-2">
            Recommended on{" "}
            <a
              href="https://restaurantguru.com/Sub-Delicious-Lockport"
              target="_blank"
              rel="noopener noreferrer"
              className="underline"
            >
              Restaurant Guru 2020
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
